var stagingConfig = {
  base_url: "http://3.16.194.5:8000/api/v1/",
};
var liveConfig = {
  base_url: "https://api.parknstays.com/api/v1/",
};
export default process.env.REACT_APP_ENV === "production"
  ? liveConfig
  : stagingConfig;